import React from 'react'
import { debounce } from 'lodash'
import {
  FormSingleSelect,
  FormMultiSelect,
  FormSingleSelectProps
} from '@contrast-security-inc/design-system-forms'
import { TYPING_DEBOUNCE_MS } from '../common/constants'
import { identity } from '../common/utils'

// TODO implement these features in Skeletor *Select
// add special indicator for new items and some
// way to detect selection of new/existing
export const MetaSelect = ({
  useSearch,
  onCreateItem = null,
  isMulti = false,
  isAsync = true,
  renderGuidance,
  ...selectProps
}: {
  useSearch?: any
  onCreateItem?: any
  isMulti?: boolean
  isAsync?: boolean
  renderGuidance?: (items: any[]) => string
} & FormSingleSelectProps<any, any, any>) => {
  const SelectComponent = isMulti ? FormMultiSelect : FormSingleSelect
  const [searchTerm, setSearchTerm] = React.useState('')
  // this item should have some sort of metadata attached
  // so it can be displayed differently to indicate that it
  // is a created item this will have to be done within the Skeletor component
  const { isLoading, items } = useSearch(searchTerm)
  const onInputChange = debounce(setSearchTerm, TYPING_DEBOUNCE_MS) as (
    value?: string
  ) => void

  let createdItem = null
  if (onCreateItem) {
    // @ts-ignore this won't matter when integrated
    const { itemToID = identity } = selectProps
    // @ts-ignore don't care
    const newItem = onCreateItem(searchTerm)

    createdItem =
      searchTerm && !items?.find((it) => itemToID(it) === itemToID(newItem))
        ? newItem
        : null
  }

  // if there is a createdItem, prepend it to the list of items
  const listItems = Array.isArray(items) ? items.slice() : []
  if (createdItem) {
    listItems.unshift(createdItem)
  }

  return isAsync || listItems.length > 0 ? (
    <SelectComponent
      isAsync={isAsync}
      isLoading={isLoading}
      items={listItems}
      onInputChange={onInputChange}
      guidance={renderGuidance ? renderGuidance(listItems) : undefined}
      {...selectProps}
    />
  ) : (
    <></>
  )
}
